import React, { Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

import FormModificaConsulente from './FormModificaConsulente';
import RegistraConsulente from './RegistraConsulente';
import EserciziXConsulenteComponent from './EserciziXConsulenteComponent';

import { getAbbonamenti } from '../../../utils/api/abbonamenti_api';
import {
  getConsulenti,
  updateConsulente,
} from '../../../utils/api/consulenti_api';
import { getGruppi, getGruppo } from '../../../utils/api/gruppi_api';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
    paddingTop: '26px',
    paddingBottom: '26px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  paper: {
    marginTop: '26px',
    marginBottom: '26px',
    boxShadow: theme.shadows[6],
  },
  tabsRoot: {
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  tabsIndicator: {
    backgroundColor: theme.palette.primary.main,
  },
  tabSelected: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
});

class DettaglioConsulente extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: 0,
      secondTabEnabled: false,
      showRegistrationForm: true,
      showRegistrationMessage: false,
      showChangesSavedMessage: false,
      consulente: {
        id: null,
        email: null,
        nome: null,
        cognome: null,
        telefono: null,
        activated: null,
        userId: null,
        validated: null,
        dataRegistrazione: null,
        terminiUsoAccettati: null,
        privacyPolicyAccettata: null,
        partitaIva: null,
        codiceSdi: null,
        pec: null,
        gruppoId: null,
        superconsulente: null,
        passwordEnabled: null,
        oauthEnabled: null,
        gestitoDaPayments: false,
      },
      notfound: true,
      readFailed: false,
      nomeGruppo: '',
      abbonamenti: [],
      loading: true,
      tipologiaPagamento: null,
      saveButtonEnabled: false,
    };
  }

  componentDidMount() {
    if (this.props.consulenteId === 'nuovo') {
      this.setState({
        secondTabEnabled: false,
        showRegistrationForm: true,
      });
    } else {
      const ID = Number.parseInt(this.props.consulenteId, 10);
      if (isNaN(ID)) {
        this.setState({
          secondTabEnabled: true,
          showRegistrationForm: false,
          loading: false,
          notfound: true,
        });
      } else {
        this.setState({
          secondTabEnabled: true,
          showRegistrationForm: false,
        });
        this.fetchRecord(ID);
      }
    }
  }

  handleTabChange = (event, newValue) => {
    this.setState({
      tabValue: newValue,
    });
  };

  fetchRecord = (consulenteId) => {
    this.setState({
      loading: true,
    });
    getConsulenti(consulenteId, this.props.gruppoId, 0, 1, 'id')
      .then((result) => {
        if (result.length > 0) {
          // Cleared as soon as the consultant arrives: a failed subscription
          // or group read must not hide a consultant that exists.
          this.setState({
            consulente: result[0],
            notfound: false,
          });
          this.fetchAbbonamenti(consulenteId);
        } else {
          this.setState({
            loading: false,
            notfound: true,
          });
        }
      })
      .catch((error) => {
        this.setState({ loading: false, readFailed: true });
        reportApiError(error);
      });
  };

  fetchAbbonamenti = (consulenteId) => {
    getAbbonamenti(null, consulenteId, null, 0, 100, 'id')
      .then((result) => {
        if (!this.props.superconsulenteView && !this.props.consulenteView) {
          this.setState({
            abbonamenti: result,
          });
          this.fetchGruppo();
        } else {
          this.setState({
            abbonamenti: result,
            loading: false,
          });
          this.fetchGruppoForConsulente(this.props.gruppoId);
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  fetchGruppo = () => {
    getGruppi(this.state.consulente.gruppoId, null, 0, 1, 'id')
      .then((result) => {
        let nomeGruppo = '';
        let tipologiaPagamento = null;
        if (result.length > 0) {
          nomeGruppo = result[0].nome;
          tipologiaPagamento = result[0].tipologiaPagamento;
        }
        this.setState({
          loading: false,
          nomeGruppo,
          tipologiaPagamento,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  fetchGruppoForConsulente = (gruppoId) => {
    getGruppo(gruppoId)
      .then((response) => {
        this.setState({
          loading: false,
          tipologiaPagamento: response.tipologiaPagamento,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  onFormSubmitted = () => {
    this.setState({
      loading: true,
    });
    let isAdmin = false;
    if (!this.props.superconsulenteView && !this.props.consulenteView) {
      isAdmin = true;
    }
    updateConsulente(isAdmin, this.state.consulente)
      .then((result) => {
        this.setState({
          loading: false,
          saveButtonEnabled: false,
          showChangesSavedMessage: true,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  onRecordSaved = () => {
    this.setState({
      secondTabEnabled: false,
      showRegistrationMessage: true,
    });
  };

  onFormModified = (fieldName, value) => {
    this.setState((prev) => ({
      saveButtonEnabled: true,
      showRegistrationMessage: false,
      showChangesSavedMessage: false,
      consulente: {
        ...prev.consulente,
        [fieldName]: value,
      },
    }));
  };

  render() {
    const { classes } = this.props;
    const showRegistrationForm = this.state.showRegistrationForm;
    // notfound stays set until a consultant is read, so this also covers a
    // failed read. Without a consultant there is no group, and reading the
    // exercises without one lists those of every group.
    const secondTabDisabled =
      !this.state.secondTabEnabled ||
      this.state.notfound ||
      (this.props.consulenteView && !this.props.superconsulenteView);
    const title = showRegistrationForm
      ? 'Nuovo consulente'
      : 'Dettagli consulente';

    return (
      <div className={classes.mainContainer}>
        <Typography variant="h4">{title}</Typography>
        {this.props.consulenteView && !this.props.superconsulenteView ? (
          <Paper className={classes.paper}>
            <Box style={{ paddingTop: '20px' }}>
              <Typography
                style={{
                  color: 'green',
                  visibility: this.state.showChangesSavedMessage
                    ? 'inherit'
                    : 'hidden',
                }}
              >
                Dati aggiornati con successo.
              </Typography>
            </Box>
            <FormModificaConsulente
              theme={this.props.theme}
              loading={this.state.loading}
              notfound={this.state.notfound}
              readFailed={this.state.readFailed}
              consulente={this.state.consulente}
              nomeGruppo={this.state.nomeGruppo}
              abbonamenti={this.state.abbonamenti}
              tipologiaPagamento={this.state.tipologiaPagamento}
              gestitoDaPayments={this.state.consulente.gestitoDaPayments}
              superconsulenteView={this.props.superconsulenteView}
              consulenteView={this.props.consulenteView}
              onFormModified={this.onFormModified}
              onFormSubmitted={this.onFormSubmitted}
              saveButtonEnabled={this.state.saveButtonEnabled}
            />
          </Paper>
        ) : (
          <Paper className={classes.paper}>
            <Tabs
              value={this.state.tabValue}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              classes={{
                indicator: classes.tabsIndicator,
                root: classes.tabsRoot,
              }}
            >
              <Tab
                label="Dati consulente"
                value={0}
                classes={{
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                label="Esercizi commerciali"
                value={1}
                disabled={secondTabDisabled}
                style={{
                  backgroundColor: secondTabDisabled
                    ? this.props.theme.palette.disabled.main
                    : 'white',
                }}
                classes={{
                  selected: classes.tabSelected,
                }}
              />
            </Tabs>
            <div hidden={this.state.tabValue !== 0}>
              <Box style={{ paddingTop: '20px' }}>
                {this.state.tabValue === 0 && showRegistrationForm ? (
                  <Fragment>
                    <Typography
                      style={{
                        color: 'green',
                        visibility: this.state.showRegistrationMessage
                          ? 'inherit'
                          : 'hidden',
                      }}
                    >
                      Registrazione effettuata con successo.
                    </Typography>
                    <RegistraConsulente
                      theme={this.props.theme}
                      gruppoId={this.props.gruppoId}
                      superconsulenteView={this.props.superconsulenteView}
                      onFormModified={this.onFormModified}
                      onFormSubmitted={this.onRecordSaved}
                    />
                  </Fragment>
                ) : null}
                {this.state.tabValue === 0 && !showRegistrationForm ? (
                  <Fragment>
                    <Typography
                      style={{
                        color: 'green',
                        visibility: this.state.showChangesSavedMessage
                          ? 'inherit'
                          : 'hidden',
                      }}
                    >
                      Dati aggiornati con successo.
                    </Typography>
                    <FormModificaConsulente
                      theme={this.props.theme}
                      loading={this.state.loading}
                      consulente={this.state.consulente}
                      notfound={this.state.notfound}
                      readFailed={this.state.readFailed}
                      nomeGruppo={this.state.nomeGruppo}
                      abbonamenti={this.state.abbonamenti}
                      tipologiaPagamento={this.state.tipologiaPagamento}
                      gestitoDaPayments={
                        this.state.consulente.gestitoDaPayments
                      }
                      superconsulenteView={this.props.superconsulenteView}
                      consulenteView={this.props.consulenteView}
                      onFormModified={this.onFormModified}
                      onFormSubmitted={this.onFormSubmitted}
                      saveButtonEnabled={this.state.saveButtonEnabled}
                    />
                  </Fragment>
                ) : null}
              </Box>
            </div>
            <div hidden={this.state.tabValue !== 1}>
              <Box style={{ paddingTop: '44px' }}>
                {this.state.tabValue === 1 && (
                  <EserciziXConsulenteComponent
                    theme={this.props.theme}
                    consulente={this.state.consulente}
                  />
                )}
              </Box>
            </div>
          </Paper>
        )}
      </div>
    );
  }
}

DettaglioConsulente.propTypes = {
  classes: PropTypes.object.isRequired,
  consulenteId: PropTypes.string.isRequired,
  gruppoId: PropTypes.number,
  consulenteView: PropTypes.bool.isRequired,
  superconsulenteView: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles)(DettaglioConsulente);
